import React from 'react';
export function FooterSection() {
  return <footer className="bg-gray-900 text-white py-10 px-4 text-center" data-id="element-41">
      <div className="max-w-3xl mx-auto" data-id="element-42">
        <p className="text-2xl md:text-3xl font-black mb-3 font-['Oswald']" data-id="element-43">
          💡 Recuerda
        </p>

        <p className="text-lg text-gray-300 mb-2" data-id="element-44">Un niño curioso hoy…</p>
        <p className="text-xl md:text-2xl font-bold text-yellow-400 mb-6" data-id="element-45">
          👉 es un adulto inteligente mañana.
        </p>

        <a href="#compra" className="bg-[#22c55e] hover:bg-[#16a34a] text-white text-lg font-bold py-4 px-8 rounded-lg shadow-[0_4px_0_#15803d] active:shadow-[0_2px_0_#15803d] active:translate-y-1 transition-all uppercase mb-8 inline-block no-underline" data-id="element-46">
          🚀 Dale a tu hijo una ventaja real desde hoy
        </a>

        <div className="border-t border-gray-800 pt-6 text-xs text-gray-500" data-id="element-47">
          <p className="mb-1" data-id="element-48">
            © 2026 El Asombroso Viaje por el Cuerpo Humano
          </p>
          <p data-id="element-49">
            Todos los derechos reservados. Privacidad · Términos y Condiciones
          </p>
        </div>
      </div>
    </footer>;
}